module.exports = __webpack_public_path__ + "static/media/02.82368bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/shoes/02.png
// module id = 639
// module chunks = 0